import axios from 'axios';
// import configData from '../../config/config.json';
const UrlAPI = JSON.parse(localStorage.getItem("UrlAPI"))

console.log(`${UrlAPI}users/login`)

// const config_json = JSON.parse('assets/config/config.json');

// export const LoginAPI2 = async (value) =>
//     await fetch(`${UrlAPI}users/login`, {
//             method: 'POST',
//             headers: {
//                 "Access-Control-Allow-Origin": "*",
//                 "Content-type": "Application/json"
//             },
//             body: JSON.stringify({
//                 username: value.username,
//                 password: value.password,
//             }),
//     })


    // await axios({
    //     method: 'post',
    //     url: configData.REACT_APP_LOGIN_URL + 'login',
    //     headers: {
    //         "Access-Control-Allow-Origin": "*",
    //         "Content-type": "Application/json"
    //     },
    //     data: {
    //         username: value.username,
    //         password: value.password,
    //     },
    // })

export const LoginAPI = async (value) =>
    await axios({
        method: 'post',
        url: process.env.REACT_APP_LOGIN_URL + 'login',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json"
        },
        data: {
            username: value.username,
            password: value.password,
        },
    })

export const UserProfile = async (Token) =>
    await axios.get(process.env.REACT_APP_LOGIN_URL + 'profile', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token}`
        }
    })

export const ForgetPass = async (value) =>
    await axios({
        method: 'post',
        url: process.env.REACT_APP_LOGIN_URL + 'forget-password',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json"
        },
        data: {
            email: value.email,
        },

    })

export const ResetPass = async (token,password) =>
    await axios({
        method: 'post',
        url: process.env.REACT_APP_LOGIN_URL + 'reset-password',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json"
        },
        data: {
            resetToken: token,
            newPass : password
        },

    })